import React from 'react';
import PropTypes from 'prop-types';
import { LogoText, PlutoProgressBar, ProgressWrapper, SvgLogo, Wrapper } from '../styles/loading';

function LoadingLogo_v2({ className, visible, text }) {
  return (
    <>
      <Wrapper visible={visible}>
        <SvgLogo>
          <svg fill="none" viewBox="0 0 407 100" width="407" xmlns="http://www.w3.org/2000/svg">
            <clipPath id="a">
              <path d="m0 0h406.473v100h-406.473z" />
            </clipPath>
            <g clipPath="url(#a)">
              <path
                d="m342.547 50c0-26.7669 2.519-33.5199 2.519-33.5199l-7.942.175c-18.825.3848-34.08 14.5556-34.08 33.3799 0 18.8244 15.255 32.9951 34.08 33.38l7.942.175c0-.07-2.519-6.788-2.519-33.59z"
                fill="#ff2cd2"
              />
              <path
                d="m342.547 49.9999c0-21.4485 11.617-33.6948 11.617-33.6948l-9.098.1749c-18.824.3849-34.079 14.6956-34.079 33.5199 0 18.8244 15.255 33.1351 34.079 33.52l9.098.1749c0 .035-11.617-12.2463-11.617-33.6949z"
                fill="#5e00ff"
              />
              <path
                d="m342.547 49.9999c0-24.2127 20.714-33.9048 20.714-33.9048l-9.097.1749c-18.825.3849-34.08 14.8706-34.08 33.6949 0 18.8244 15.255 33.3101 34.08 33.695l9.097.1749c0 .07-20.714-9.6221-20.714-33.8349z"
                fill="#ffde2b"
              />
              <path
                d="m342.547 50c0-15.7803 10.252-32.1554 28.517-34.0448l-7.803.1749c-18.824.3849-34.08 15.0805-34.08 33.9049 0 18.8243 15.256 33.5199 34.08 33.9048l7.838.1749c-18.23-1.9594-28.552-18.3344-28.552-34.1147z"
                fill="#ff6700"
              />
              <g fill="#fff">
                <path d="m372.358 15.9202c-18.824 0-34.079 15.2554-34.079 34.0797 0 18.8244 15.255 34.0798 34.079 34.0798 18.825 0 34.08-15.2554 34.08-34.0798.035-18.8243-15.255-34.0797-34.08-34.0797zm13.471 50.7347h-6.368l-9.097-22.0084h-9.132v11.3366c0 2.4493 1.189 3.9539 3.953 3.9539h4.024v6.683h-4.968c-6.718 0-10.322-3.8139-10.322-10.182v-11.8264h-5.039v-6.4031h5.039v-4.5487l7.278-2.9391v7.4878h14.345l7.033 18.3695 7.103-18.5445h7.873z" />
                <path d="m259.377 15.9202c-18.824 0-34.08 15.2554-34.08 34.0798s15.256 34.0798 34.08 34.0798c18.825 0 34.08-15.2554 34.08-34.0798.035-18.8244-15.255-34.0798-34.08-34.0798zm0 49.7201c-8.642 0-15.64-6.9979-15.64-15.6403s6.998-15.6403 15.64-15.6403c8.643 0 15.64 6.9979 15.64 15.6403s-6.997 15.6403-15.64 15.6403zm-54.618-30.8607v21.0986c0 6.4731 2.869 9.3422 9.342 9.3422h6.508v17.5648h-9.482c-7.908 0-14.381-2.3093-18.79-6.683-4.408-4.3737-6.718-10.8468-6.718-18.6844v-22.6382h-11.721v-17.5648h11.756v-9.48212l19.105-7.73268v17.2148h15.885v17.5648zm-38.349-17.5648v35.8643c0 17.1098-13.856 31.0007-31.001 31.0007-17.144 0-31-13.8559-31-31.0007v-27.4668l18.964-7.6627v35.7243c0 6.613 5.388 12.0014 12.001 12.0014s12.002-5.3884 12.002-12.0014v-28.7964zm-70.1889-17.2148v82.7852h-19.1042v-75.05252zm-58.3275 15.9202c-7.9776 0-14.7655 2.6942-19.804 7.8377l-2.6242-6.3681-15.4654 6.2281v76.3821h19.1043v-22.5682c4.9685 4.4786 11.4065 6.648 18.7893 6.648 8.7474 0 16.795-3.534 22.6732-9.972 5.8083-6.3331 8.9923-14.8706 8.9923-24.0378.035-19.1393-13.8908-34.1498-31.6655-34.1498zm-2.9391 49.7201c-8.7824 0-15.9202-6.9979-15.9202-15.6403s7.1029-15.6403 15.9202-15.6403c8.7824 0 15.9202 6.9979 15.9202 15.6403s-7.1378 15.6403-15.9202 15.6403z" />
              </g>
            </g>
          </svg>
        </SvgLogo>
        <LogoText id="loading-text">{text}</LogoText>
        <ProgressWrapper className="siteWideLogo">
          <PlutoProgressBar
            alt="Pluto TV progress"
            path="images/progressLoader.10.2020.gif"
            className="siteWideLogo"
          />
        </ProgressWrapper>
      </Wrapper>
    </>
  );
}

LoadingLogo_v2.propTypes = {
  visible: PropTypes.bool,
  className: PropTypes.string,
};

LoadingLogo_v2.defaultProps = {
  visible: true,
  className: null,
};

export default LoadingLogo_v2;
